import { Component, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges } from '@angular/core';
import {NgbDate, NgbDateStruct, NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { ModalStatusService } from '../../../shared/services/modal-status.service';
import { IDestinationBoxElement } from '../../interfaces/idestination-box-element';
import { IEngineParamChange } from '../../interfaces/iengine-param-change';

import { EngineTabTypes } from '../../models/engine-tab-types.enum';
import {
  EngineTourModalDatepickerComponent
} from "../engine-tour-modal-datepicker/engine-tour-modal-datepicker.component";

@Component({
  selector: 'app-engine-tour-control-datepicker',
  templateUrl: './engine-tour-control-datepicker.component.html',
  styleUrls: ['./engine-tour-control-datepicker.component.scss']
})
export class EngineTourControlDatepickerComponent implements OnChanges, OnDestroy {

  @Input() selectedDestination: IEngineParamChange<IDestinationBoxElement>;
  @Input() onlyCustomHoliday: boolean;
  @Output() selectedDate = new EventEmitter<IEngineParamChange<NgbDateStruct>>();
  @Input() defaultDate: string;
  @Input() engineTabType: EngineTabTypes;

  selectedDateInternal: NgbDateStruct;
  loadingStatus: boolean;
  loadingMessage: string;

  dpModalRefSubscription: Subscription;

  private dpModalRef: NgbModalRef;

  constructor(private _modalService: NgbModal, private _modalStatusService: ModalStatusService) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.selectedDestination && this.selectedDestination?.resetParams) {
      this.selectDate(undefined);
    }
    if (this.defaultDate) {
      const tmpDate = this.defaultDate.split('-').map(i => parseInt(i, 10));
      this.selectedDateInternal = new NgbDate(tmpDate[0], tmpDate[1], tmpDate[2]);
    }
  }

  selectDate(param: IEngineParamChange<NgbDateStruct>): void {
    this.selectedDateInternal = param?.value;
    this.selectedDate.emit(param);
  }

  open(): void {
    if (!this._modalService.hasOpenModals()) {
      this._modalStatusService.hasOpenModals.next(true);
      this.dpModalRef = this._modalService.open(EngineTourModalDatepickerComponent, {
        ariaLabelledBy: 'modal-engine', size: 'md'
      });
      this.dpModalRef.componentInstance.selectedDestination = this.selectedDestination;
      this.dpModalRef.componentInstance.engineTabType = this.engineTabType;
      this.dpModalRef.componentInstance.onlyCustomHoliday = this.onlyCustomHoliday;
      this.dpModalRef.componentInstance.defaultDate = this.defaultDate;
      setTimeout(() => {
        this.dpModalRefSubscription = this.dpModalRef.componentInstance.selectedDate.subscribe(e => {
          this.selectDate(e);
        });
      });
      this.dpModalRef.result.finally(() => this._modalStatusService.hasOpenModals.next(false));
    }
  }

  ngOnDestroy(): void {
    this.dpModalRefSubscription?.unsubscribe();
  }

}
